export const authorIdFromModel = (model: any) => {
  if (!model || !model.author) {
    return undefined;
  }
  return model.author.id;
};

export default authorIdFromModel;
